import React from 'react';
import axios from 'axios';
import { Form, Select, Input, message } from 'antd';

import apiPath from 'apiPath';
import formItemLayout from 'components/Portal/formItemLayout';
import AddressInput from 'components/AddressInput';
import SaveButton from 'components/SaveButton';
import withSpin from 'components/withSpin';

const addressFields = ['Country','Street','City','Province','PostalCode'];

class SchoolAddress extends React.Component {
	state = {
		schoolsLoaded: false,
		allSchools: [],
		schools: [],
		schoolSearchBlank: true,
		addressEditable: false
	}
	loadSchools = () => {
		axios.get(apiPath+'/schools', {withCredentials: true}).then(result => {
			this.setState({ allSchools: result.data, schoolsLoaded: true });
		}).catch(this.props.handleAxiosLoadError);
	}
	handleSchoolSearch = (value) => {
		this.setState({ addressEditable: false });
		if (this._timeout) window.clearTimeout(this._timeout);
		this._timeout = window.setTimeout(() => {
			this.setState({
				schools: this.state.allSchools.filter(school => {
					if (value.length < 3) return false;
					if (value === school.cmpCode) return true;
					if (school.cmpName1.toLowerCase().indexOf(value.toLowerCase()) !== -1) return true;
					if (school.cmpName1.split(' ').map(word => word.substring(0,1)).join('').toLowerCase().indexOf(value.toLowerCase()) === 0) return true;
					return false;
				})
			});
		}, 500);
	}
	handleSchoolChange = (value) => {
		if (typeof value === 'undefined') {
			this.setState({ schools: [] });
			return this.props.form.resetFields();
		}
		if (value.indexOf('.') === -1) return this.handleSchoolSearch(value);
		const folioid = value.split('.')[0];
		axios.get(apiPath+'/schoolcontacts/'+folioid, {withCredentials: true}).then(result => {
			const address = result.data.find(address => address.type === this.props.rescoAddressType);
			let values = {};
			addressFields.concat(['id']).map(field => {
				if (typeof address !== 'undefined') return values[field] = address[field]
				return values[field] = '';
			});
			this.props.form.setFieldsValue(values);
			this.setState({ addressEditable: true });
		}).catch(this.props.handleAxiosLoadError);
	}
	makeAddressSaveRequest = (type, values) => {
		const folioid = values.School.split('.')[0];
		const addressid = values['id'];
		let address = {};
		addressFields.map(field => address[field] = values[field]);
		address['type'] = (type === 'Transcript')? '2': (type === 'Invoice')? 'I': '';
		if (address['type'] === '') return;
		if (addressid !== null && addressid !== '') {
			address['id'] = addressid;
			return axios.put(apiPath+'/schoolcontact/'+folioid, address, {withCredentials: true});
		}
		return axios.post(apiPath+'/schoolcontact/'+folioid, address, {withCredentials: true});
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((errors, values) => {
			if (errors) {
				message.error('Validation error');
				this.props.isSubmitted();
				return console.error(errors);
			}
			this.makeAddressSaveRequest(this.props.addressType, values).then(result => {
				this.props.isSubmitted();
				message.success('Saved!');
			}).catch(error => {
				this.props.isSubmitted();
				message.error('An error occurred');
			});
		});
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.addressType !== nextProps.addressType) {
			this.handleSchoolChange(this.props.form.getFieldValue('School'))
		}
	}
	componentDidMount() { this.loadSchools() }
	render() {
		const { getFieldDecorator } = this.props.form;
		return (
			<div className="withSpacing">
				<h1 style={{margin: '16pt 32pt'}}>
					School Information
				</h1>
				<Form onSubmit={this.handleSubmit} className="withSpacing">
					<Form.Item className="withSpacing">
						{getFieldDecorator('School', {})(
							<Select mode="combobox" allowClear
								disabled={!this.state.schoolsLoaded}
								placeholder={(this.state.schoolsLoaded)? 'School Name or CEEB Code': 'Loading school list...'}
								filterOption={false}
								onChange={this.handleSchoolChange}
								optionLabelProp="children">
								{this.state.schools.map(school => {
									return <Select.Option key={school.folUId+'.'}>
										{school.cmpName1+' ('+school.cmpCode+')'}
									</Select.Option>
								})}
							</Select>
						)}
					</Form.Item>
					<Form.Item>{getFieldDecorator('id',{})(<Input type="hidden" />)}</Form.Item>
					<legend style={{width:'auto', margin:'8pt', padding:'8pt'}}>{this.props.addressType} Address</legend>
					<AddressInput
						showAbbreviations
						disabled={!this.state.addressEditable}
						address={{}}
						form={this.props.form}
						getFieldDecorator={getFieldDecorator} />
					<SaveButton
						disabled={!this.props.form.isFieldsTouched(addressFields)}
						loading={this.props.getStatus().submitting} />
				</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(SchoolAddress));



// WEBPACK FOOTER //
// ./portal-components/Portal/SchoolInformation/SchoolAddress.jsx